import React from 'react';
import { jsx } from '@emotion/core'; // @ts-ignore
// eslint-disable-next-line @typescript-eslint/camelcase

import { arrowRight_16 } from '@trustpilot/icons';
import { Icon } from '../../Icon';
import Item from './item';
import { breadcrumb, mobileDivider, desktopDivider } from './styled';
/* eslint-disable @typescript-eslint/camelcase */

var MobileDivider = function MobileDivider() {
  return jsx(Icon, {
    css: mobileDivider,
    content: arrowRight_16
  });
};

var DesktopDivider = function DesktopDivider() {
  return jsx(Icon, {
    css: desktopDivider,
    content: arrowRight_16
  });
};

var Breadcrumb = function Breadcrumb(_a) {
  var children = _a.children;
  var arrayOfChildren = React.Children.toArray(children);
  var elements = arrayOfChildren.map(function (children, index) {
    return {
      item: children,
      key: index
    };
  });
  return jsx("div", {
    css: breadcrumb
  }, elements.length > 1 && jsx(MobileDivider, null), elements.map(function (c, index) {
    if (!React.isValidElement(c.item)) {
      return null;
    }

    if (index === elements.length - 1) {
      return jsx(React.Fragment, {
        key: c.key
      }, React.cloneElement(c.item, {
        active: true,
        href: null
      }));
    }

    return jsx(React.Fragment, {
      key: c.key
    }, React.cloneElement(c.item, {
      context: null
    }), index !== elements.length - 1 && jsx(DesktopDivider, null));
  }));
};

Breadcrumb.Item = Item;
export default Breadcrumb;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Header/breadcrumbs/index.js
// module id = 334
// module chunks = 0